import { FunctionComponent } from 'react'

import styled from 'styled-components'

import useSnackbar from '@hooks/useSnackbar'

import SnackbarItem from './SnackbarItem'

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  z-index: 10001;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`

const Snackbars: FunctionComponent = () => {
  const { snackbars, hideSnackbar } = useSnackbar()

  if (!snackbars?.length) {
    return null
  }

  return (
    <Container>
      {snackbars.map((snackbar) => (
        <SnackbarItem
          key={snackbar.id}
          snackbar={snackbar}
          onHide={hideSnackbar}
        />
      ))}
    </Container>
  )
}

export default Snackbars
